export default "__VITE_ASSET__BDkgKEqS__"